import styles from "./DeleteConfirmation.module.css";
import Backdrop from "../Dialog/Backdrop";

export const DeleteConfirmation = ({ show, handleCancel, handleConfirm }) => {
  return show ? (
    <div>
      <Backdrop show={show} switch={handleCancel} />
      <div className={styles.deleteDialog}>
        <h2 className={styles.deleteTitle}>Delete Product</h2>
        <p className={styles.deleteMessage}>
          This action will permanently delete the selected product. You can't
          undo this.
        </p>
        <div className={styles.buttonContainer}>
          <button className={styles.cancelButton} onClick={handleCancel}>
            Cancel
          </button>
          <button className={styles.deleteButton} onClick={handleConfirm}>
            Yes, Delete
          </button>
        </div>
      </div>
    </div>
  ) : null;
};
